//src/app/features/auth/signUp/step-two/formFields.ts
import * as Yup from 'yup';

export type FormFieldsTwo = {
  hearAboutUs: string;
  other: string;
};

export const initialData: FormFieldsTwo = {
  hearAboutUs: '',
  other: '',
};

export const validationSchema = Yup.object().shape({
  other: Yup.string().when('hearAboutUs', {
    is: 'Other',
    then: Yup.string().required('required'),
    otherwise: Yup.string(),
  }),
});
